import { Col, Form, Row } from 'antd';
import React, { useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { IHlasovaniHromadne, IHlasovaniHromadneBody } from 'services/spravceUctu/hromadneHlasovani';

import { EHlasovani } from 'enums/akcionarKorpAkce/hlasovani';

interface HlasovaniProps {
    page: number;
    body: IHlasovaniHromadneBody;
    bodyHlasovani: IHlasovaniHromadne;
    zapsanyHlas: IHlasovaniHromadne;
    indexBody: number;
    updateHlasovani: (v: IHlasovaniHromadne) => void;
    setConfirmContinue: React.Dispatch<React.SetStateAction<boolean[] | undefined>>;
    submiting: boolean;
    setAllowToPut: React.Dispatch<React.SetStateAction<boolean>>;
}

const HlasovaniHromadne: React.FC<HlasovaniProps> = ({
    page,
    body,
    bodyHlasovani,
    zapsanyHlas,
    indexBody,
    updateHlasovani,
    setConfirmContinue,
    submiting,
    setAllowToPut
}) => {
    const [, setRerender] = useState<boolean>(false);
    const typHlasovani = body.hlasovani.map(e => e.hlasovani);
    const [form] = Form.useForm();
    useEffect(() => {
        if (submiting) {
            setConfirmContinue(pv => {
                if (pv) {
                    const newState = [...pv];
                    newState[indexBody] = false;
                    return newState;
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submiting]);

    const zapsatHlasovani = (issrlabl: string, typhlasu: EHlasovani) => {
        setAllowToPut(true);
        updateHlasovani({
            issrlabl,
            typhlasu: typhlasu
        });
    };

    const zrusitHlasovani = (issrlabl: string) => {
        const bodyHlas: IHlasovaniHromadne = {
            issrlabl: issrlabl,
            typhlasu: EHlasovani.NULL
        };
        updateHlasovani(bodyHlas);
        setAllowToPut(true);
    };

    return (
        <>
            <Row>
                <Col>
                    <Paragraph text={'AKCIONAR_HLASOVANI_MAXPOCET_SELECT'} />
                </Col>
            </Row>

            {page > 1 && (
                <Row>
                    <Col span={24}>
                        <FormWrapper
                            onFinish={() => zapsatHlasovani(body.issrlabl, form.getFieldValue('selectTyp'))}
                            layoutPosition="inline"
                            outForm={form}
                        >
                            <Col span={8}>
                                <SelectComponent
                                    isFormItem={true}
                                    name={'selectTyp'}
                                    data={typHlasovani.map(hlasovani => ({
                                        value: hlasovani,
                                        labelcz: hlasovani
                                    }))}
                                    placeholder={bodyHlasovani.typhlasu ? bodyHlasovani.typhlasu : 'NULL'}
                                    disabled={page === 3 || (page === 2 && !!zapsanyHlas)}
                                    validateTrigger="onSubmit"
                                    rules={[
                                        {
                                            validateTrigger: 'onSubmit'
                                        },
                                        {
                                            validator(_rule, value: string) {
                                                try {
                                                    if (value === 'VYBERTE' || !value)
                                                        return Promise.reject(
                                                            <TranslateText>NEVALIDNI_POVINNA_POLOZKA</TranslateText>
                                                        );
                                                    return Promise.resolve();
                                                } catch {
                                                    return Promise.reject();
                                                }
                                            }
                                        }
                                    ]}
                                    onChange={() => setRerender(pv => !pv)}
                                />
                            </Col>
                            <Col offset={1} span={6}>
                                {page === 2 && form.getFieldValue('selectTyp') && !zapsanyHlas && (
                                    <ButtonComponent
                                        onClick={() => form.submit()}
                                        buttontext="ZAPSAT"
                                        id={'hlasovaniZapsatBtn'}
                                    />
                                )}
                                {page === 2 && !!zapsanyHlas && (
                                    <ButtonComponent
                                        buttontext="ZRUSIT"
                                        id={'hlasovaniZrusitBtn'}
                                        onClick={() => {
                                            zrusitHlasovani(body.issrlabl);
                                        }}
                                    />
                                )}
                            </Col>
                        </FormWrapper>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default HlasovaniHromadne;
